var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 73C56.6589 73 73 56.659 73 36.5C73 16.3411 56.659 6.20081e-06 36.5 4.43846e-06C16.341 2.67611e-06 -2.67611e-06 16.3411 -4.43846e-06 36.5C-6.20081e-06 56.6589 16.341 73 36.5 73ZM36.5 65.7C20.3998 65.7 7.3 52.6001 7.3 36.5C7.3 20.3999 20.3998 7.3 36.5 7.3C52.6001 7.3 65.7 20.3999 65.7 36.5C65.7 52.6002 52.6001 65.7 36.5 65.7ZM31.025 51.1L49.275 36.5L31.025 21.9L31.025 33.5771L31.025 36.5L31.025 37.8687L31.025 39.4228L31.025 51.1Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.af9252f95dc0f23b4079084fb797f6ba.svg";
export { ForwardRef as ReactComponent };